module.exports = __webpack_public_path__ + "static/media/textOnPhoto.a04c7ea8.png";